import { useEffect, useState } from 'react'
import Meloclidean from './pages/Meloclidean'

import seqStore from './store/seqStore'

function App() {

  const currentTrack = seqStore((state) => state.settings.currentTrack)
  const [currentTrackTheme, setCurrentTrackTheme] = useState(0)
  useEffect(()=>{
    switch (currentTrack) {
      case 0:
        setCurrentTrackTheme('themeTrack1')
        break
      case 1:
        setCurrentTrackTheme('themeTrack2')
        break
      case 2:
        setCurrentTrackTheme('themeTrack3')
        break
      case 3:
        setCurrentTrackTheme('themeTrack4')
        break
      default:
        setCurrentTrackTheme("themeTrack1")
    }
  }, [currentTrack])


  return (
    <div className={currentTrackTheme}>
      <Meloclidean />
    </div>
  )
}

export default App
